// Topbar actions container
// Created as part of ENG2-1700: Create Topbar Component

import React from 'react'
import { Box } from '@mui/material'
import { TopbarActionsProps } from './topbar.types'

const TopbarActions: React.FC<TopbarActionsProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      {children}
    </Box>
  )
}

export default TopbarActions
